import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Grid } from "@mui/material"
import Tooltip from "components/material/tooltip"
import ResourceTooltipInfo from "components/resource-tooltip-info"

export default function ResourceName({ account, resource, hasModels, openBasket }) {
  const { name, alias, shortType } = resource
  const label = name || alias

  let component = <Link to={`/${account}/${shortType}/${alias}`}>{label}</Link>
  if (shortType === "b") {
    component = <a href="#" onClick={openBasket}>{label}</a>
  }

  if (!hasModels) {
    component = <Tooltip title="Access to this resource is disabled because you do not have access to any risk model">
      <span>{label}</span>
    </Tooltip>
  }

  return <Grid container className="name-container" alignItems="stretch">
    <Grid item className="name">{component}</Grid>
    <Grid item className="tooltip"><ResourceTooltipInfo {...resource} /></Grid>
  </Grid>
}

ResourceName.propTypes = {
  account: PropTypes.string.isRequired,
  resource: PropTypes.object.isRequired,
  hasModels: PropTypes.bool.isRequired,
  openBasket: PropTypes.func.isRequired,
}
